<template>
  <div class="order-submission">
    <div class="allAddress" :style="store_self_mention ? '' : 'padding-top: 0.2rem'">
      <!-- <div class="nav acea-row">
        <div class="item font-color-red" :class="shipping_type === 0 ? 'on' : 'on2'" @click="addressType(0)" v-if="store_self_mention"></div>
        <div class="item font-color-red" :class="shipping_type === 1 ? 'on' : 'on2'" v-if="store_self_mention"></div>
      </div> -->
      <div class="address acea-row row-between-wrapper" v-if="shipping_type === 0" @click="addressTap">
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default">[默认]</span>
            {{ addressInfo.province }}{{ addressInfo.city }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
          
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-else @click="showStoreList">
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <div v-text="storeItem.address + ',' + storeItem.detailed_address" v-if="storeItem && storeItem.address && storeItem.detailed_address"></div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <!-- 提示 -->
      <div class="prompt acea-row row-between-wrapper">  
        <span class="bei" style="color: red;">
          您填写的寄送信息将用于商品寄送及售后服务，如您不同意可选择终止下单。
        </span>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <!-- <div class="item acea-row row-between-wrapper" @click="couponTap" v-if="deduction === false">
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div class="item acea-row row-between-wrapper" v-if="orderGroupInfo.priceGroup.vipPrice > 0 && userInfo.vip && pinkId == 0 && orderGroupInfo.bargain_id == 0 && orderGroupInfo.combination_id == 0 && orderGroupInfo.seckill_id == 0">
        会员优惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">
          {{ orderPrice.pay_postage > 0 ? "￥" + orderPrice.pay_postage : "免运费" }}
        </div>
      </div> -->
    </div>
    <!-- <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div class="payItem acea-row row-middle" :class="active === 'weixin' ? 'on' : ''" @click="payItem('weixin')" v-show="isWeixin">
            <div class="name acea-row row-center-wrapper">
              <div class="iconfont icon-weixin2" :class="active === 'weixin' ? 'bounceIn' : ''"></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div class="payItem acea-row row-middle" :class="active === 'weixin' ? 'on' : ''" @click="payItem('weixin')" v-show="!isWeixin">
            <div class="name acea-row row-center-wrapper">
              <div class="iconfont icon-weixin2" :class="active === 'weixin' ? 'bounceIn' : ''"></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div class="payItem acea-row row-middle" :class="active === 'yue' ? 'on' : ''" @click="payItem('yue')">
            <div class="name acea-row row-center-wrapper">
              <div class="iconfont icon-icon-test" :class="active === 'yue' ? 'bounceIn' : ''"></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div class="payItem acea-row row-middle" :class="active === 'offline' ? 'on' : ''" @click="payItem('offline')" v-if="offlinePayStatus === 1 && deduction === false && shipping_type === 0">
            <div class="name acea-row row-center-wrapper">
              <div class="iconfont icon-yinhangqia" :class="active === 'offline' ? 'bounceIn' : ''"></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="moneyList">
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined">
        <div>商品总价</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>运费</div>
        <div class="money">{{ orderPrice.pay_postage > 0 ? "￥" + orderPrice.pay_postage : "包邮" }}</div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined">
        <div></div>
        <div class="money">
          <span style="font-size:0.3rem;">合计：</span>
          <span>￥{{ orderPrice.pay_price.toFixed(2) }}</span>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="orderPrice.coupon_price > 0">
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.deduction_price > 0">
        <div>积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div>
    </div>

    <div class="wrapper">
      <div class="item acea-row row-between-wrapper" style="font-size:0.28rem" @click="invoiceShow = true">
        <div>发票</div>
        <div class="discount" style="margin-right:-0.8rem;color: red;" v-if="invoiceInfo.header">电子票</div>
        <div class="discount" style="margin-right:-0.8rem;font-size:0.28rem;" v-else>
          不使用发票
        </div>
        <div style="font-size:0.26rem" class="iconfont icon-jiantou"></div>
      </div>
    </div>

    <!-- 寄送信息授权书勾选 -->
    <div class="wrapper auth-agree-wrapper">
      <div class="auth-agree-row" @click="authAgreed = !authAgreed">
        <span class="auth-check-box" :class="{ checked: authAgreed }">
          <span v-if="authAgreed" class="auth-tick">✓</span>
        </span>
        <span class="auth-agree-text">我已阅读并同意</span>
        <span class="auth-link" @click.stop="authShow = true">《寄送信息授权书》</span>
      </div>
    </div>

    <div class="wrapper">
      <div class="item">
        <div style="font-size:0.28rem">备注</div>
        <textarea placeholder="请添加备注（150字以内）" v-model="mark"></textarea>
      </div>
    </div>

    <div class="discount footer" style="background-color: #fce9e5; margin-bottom: 0.5rem;padding: 0.1rem 0;text-align: center; font-size:0.25rem;color: #ea4233;">支持{{ orderGroupInfo.fenqi_num }}期免息，可在”下一步”选择期数</div>
    <div style="height:1.5rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="mx-box">
        <span class="mx">兔息</span>
        <span class="font-color-red" style="font-size:0.3rem;font-weight:bold;">￥{{ orderGroupInfo.fenqi_price }}</span>
        /期起
      </div>
      <div class="settlement" @click="createOrder">下一步</div>
    </div>
    <CouponListWindow v-on:couponchange="changecoupon($event)" v-model="showCoupon" :price="orderPrice.total_price" :checked="usableCoupon.id" :cartid="cartid" @checked="changeCoupon"></CouponListWindow>
    <AddressWindow @checked="changeAddress" @redirect="addressRedirect" v-model="showAddress" :checked="addressInfo.id" ref="mychild"></AddressWindow>

    <!-- 接口支付成功，跳转交行支付页面 -->
    <div>
      <a ref="autoLink" :href="pay_html_url" rel="noopener noreferrer" style="display: none;"></a>
    </div>

    <van-popup v-model="invoiceShow" lock-scroll closeable round position="bottom">
      <div class="container">
        <div class="tips">
          <img style="width:24px;height:24px;" src="@assets/images/tips.png" />
          <div class="content">
            发票由商家提供，订单确认收货后10个工作日内开票，如紧急请联系商家客服协助！
          </div>
        </div>
        <div class="operater">
          <div class="item">
            <div class="in-1">开票金额</div>
            <div class="in-2" style="color:red;">具体以最终实付金额为准</div>
          </div>
          <div class="item">
            <div class="in-1">发票抬头</div>
            <div>
              <span @click="handleType(1)" class="t" :class="{ itemCheck: type == 1 }">个人</span>
              <span @click="handleType(2)" class="t" :class="{ itemCheck: type == 2 }">企业</span>
            </div>
          </div>
        </div>

        <!-- 个人 -->
        <div class="content-g" v-if="type == '1'">
          <div class="item">
            <div class="title">抬头名称<span class="ck">*</span></div>
            <input type="text" placeholder="个人/非企业性单位" v-model="header" />
          </div>
          <div class="item">
            <div class="title">手机号码<span class="ck">*</span></div>
            <input type="tel" max="11" placeholder="请输入手机号" v-model="phone" />
          </div>
          <div class="item">
            <div class="title">邮箱地址<span class="ck">*</span></div>
            <input type="email" placeholder="用于接收发票的邮箱" v-model="email" />
          </div>
        </div>

        <!-- 企业 -->
        <div class="content-g" v-else>
          <div class="item">
            <div class="title">抬头名称<span class="ck">*</span></div>
            <input type="text" placeholder="请输入企业名称或代开代码" v-model="header" />
          </div>
          <div class="item">
            <div class="title">税号<span class="ck">*</span></div>
            <input type="text" placeholder="请输入6-20位企业税号" v-model="taxId" />
          </div>
          <div class="item">
            <div class="title">手机号码<span class="ck">*</span></div>
            <input type="tel" max="11" placeholder="请输入手机号" v-model="phone" />
          </div>
          <div class="item">
            <div class="title">邮箱地址<span class="ck">*</span></div>
            <input type="text" placeholder="用于接收发票的邮箱" v-model="email" />
          </div>
        </div>
        <div class="returnBnt" @click="invoiceSubmit">提交</div>
      </div>
    </van-popup>

    <!-- 寄送信息授权书弹窗（底部下拉浏览） -->
    <van-popup v-model="authShow" position="bottom" lock-scroll closeable round :style="{ maxHeight: '80%' }">
      <div class="auth-popup">
        <div class="auth-popup-header">信息核验授权书</div>
        <div class="auth-popup-scroll">
          <AuthLetter />
        </div>
        <div class="auth-popup-footer" @click="agreeAuth">我已阅读并同意</div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped lang="scss">
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 0.2rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}

.prompt {
  padding-left :  10px;
  padding-right :  10px;        
  padding-bottom :  5px;          
  padding-top :  5px;
}
.bei {
    font-size :  0.26rem;
    color :    #666;
    display :  inline-block;
    text-indent :  2em;
    padding-left :  6px;
    padding-right :  6px;
}
.auth-agree-wrapper {
  .auth-agree-row {
    display: flex;
    align-items: center;
    padding: 0.2rem 0.24rem;
    font-size: 0.26rem;
    color: #333;
  }
  .auth-check-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 0.36rem;
    height: 0.36rem;
    border: 0.02rem solid #ccc;
    border-radius: 0.06rem;
    margin-right: 0.12rem;
    flex-shrink: 0;

    &.checked {
      background: #e93323;
      border-color: #e93323;
    }
    .auth-tick {
      color: #fff;
      font-size: 0.24rem;
      font-weight: bold;
      line-height: 1;
    }
  }
  .auth-link {
    color: #e93323;
  }
}
</style>
<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import AuthLetter from "@components/AuthLetter";
import attrs, { required, chs_phone, email } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { storeListApi } from "@api/store";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow,
    AuthLetter,
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function() {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    },
  },
  data: function() {
    return {
      cartid: "",
      type: 1, //发票类型 1-个人  2-企业
      order_id: "",
      header: "",
      taxId: "",
      phone: "",
      email: "",
      invoiceInfo: {},
      invoiceShow: false,
      authAgreed: false,
      authShow: false,
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      from: "jiaohang",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      // active: _isWeixin ? "weixin" : "yue",
      active: "jiaohang",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {},
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中",
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      pay_html_url: "",
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) {
        console.log(this.$route.query.pinkid);
        if (this.$route.query.pinkid !== undefined) this.pinkId = this.$route.query.pinkid;
        else {
          this.pinkId = 0;
        }
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    },
  },
  mounted: function() {
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    that.getList();
    if (this.$route.query.pinkid !== undefined) this.pinkId = this.$route.query.pinkid;
    if (that.$route.params.id !== undefined) that.cartid = that.$route.params.id;
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    handleType(type) {
      this.type = type;
    },
    agreeAuth() {
      this.authAgreed = true;
      this.authShow = false;
    },
    // 获取门店列表数据
    getList: function() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10,
      };
      storeListApi(data)
        .then((res) => {
          this.storeList = res.data.list[0];
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
        });
    },
    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    getUserInfo() {
      getUser()
        .then((res) => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function(index) {
      if (index && !this.system_store.id) return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.active,
      })
        .then((res) => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId,
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then((res) => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function() {
      // this.$router.push({ path: "/user/add_manage" });

      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
      this.computedPrice();
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.authAgreed) return this.$dialog.toast({ mes: "请先阅读并同意《寄送信息授权书》" });
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (!this.addressInfo.id && !this.shipping_type) return this.$dialog.toast({ mes: "请选择收货地址" });
      if (this.shipping_type) {
        if ((this.contacts === "" || this.contactsTel === "") && this.shipping_type) return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }
      this.$dialog.loading.open("生成订单中");
      createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        invoiceInfo: this.invoiceInfo,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.active,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        shipping_type: parseInt(shipping_type) + 1,
        store_id: this.storeItem ? this.storeItem.id : 0,
      })
        .then((res) => {
          this.$dialog.loading.close();
          this.pay_html_url = res.data.result.url;
          this.$nextTick(() => {
            this.$refs.autoLink.click();
          });

          // let url = "/order/status/" + data.result.orderId;
          // switch (data.status) {
          //   case "ORDER_EXIST":
          //   case "EXTEND_ORDER":
          //   case "PAY_DEFICIENCY":
          //   case "PAY_ERROR":
          //     this.$dialog.toast({ mes: res.msg });
          //     this.$router.replace({
          //       path: url + "/0?msg=" + res.msg,
          //     });
          //     break;
          //   case "SUCCESS":
          //     this.$dialog.success(res.msg);
          //     this.$router.replace({
          //       path: url + "/1",
          //     });
          //     break;
          //   case "WECHAT_H5_PAY":
          //     this.$router.replace({
          //       path: url + "/2",
          //     });
          //     setTimeout(() => {
          //       location.href = data.result.jsConfig.mweb_url;
          //     }, 100);
          //     break;
          //   case "WECHAT_PAY":
          //     pay(data.result.jsConfig).finally(() => {
          //       this.$router.replace({
          //         path: url + "/4",
          //       });
          //     });
          // }
        })
        .catch((err) => {
          this.$dialog.error(err.msg || "创建订单失败");
          this.$dialog.loading.close();
          this.$router.go(-1);
        });
    },
    invoiceSubmit: function() {
      let reg = RegExp(/交通银行/);
      if (reg.test(this.header) || this.header == "") {
        return this.$dialog.error("请填写正确的抬头名称");
      }
      if (this.type == 2) {
        if (reg.test(this.taxId) || this.taxId == "") {
          return this.$dialog.error("请填写正确的税号");
        }
      }
      const reg1 = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (!reg1.test(this.phone) || this.phone == "") {
        return this.$dialog.error("请填写正确的手机号");
      }
      const reg2 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!reg2.test(this.email) || this.email == "") {
        return this.$dialog.error("请填写正确的邮箱");
      }
      let data = {
        type: this.type,
        header: this.header,
        taxId: this.taxId,
        phone: this.phone,
        email: this.email,
      };
      this.invoiceInfo = data;
      this.invoiceShow = false;
    },
  },
};
</script>

<style lang="scss">
.yd-dialog-white-mask {
  z-index: 3000 !important;
}

.container {
}

.tips {
  display: flex;
  align-items: center;
  padding: 0.8rem 0.4rem 0.2rem;
  .content {
    font-size: 0.24rem;
    color: #b1b1b1;
    margin-left: 8px;
  }
}

.operater {
  background: white;
  padding: 0 12px;
  .item {
    display: flex;
    align-items: center;
    padding: 14px 0;
    .item-t {
      font-size: 0.24rem;
      color: white;
      background: red;
      padding: 8px 12px;
      border-radius: 25px;
      line-height: 1;
    }
    .t {
      padding: 8px 20px;
      margin-right: 24px;
      background: none;
      border: #ececec 1px solid;
      color: black;
      border-radius: 25px;
    }
    .itemCheck {
      pointer-events: auto !important;
      font-size: 14px;
      color: white;
      background: red;
      padding: 8px 20px;
      border-radius: 25px;
      line-height: 1;
      border: none;
    }
    .in-1 {
      margin-right: 50px;
    }
  }
  .bor {
    border-top: #ececec 1px solid;
    border-bottom: #ececec 1px solid;
  }
}

.content-g input {
  width: 100%;
  margin-left: 0.4rem;
}

.content-g {
  background: white;
  padding: 0 12px;
  margin-top: 20px;
  .title {
    width: 100px;
  }
  .ck {
    color: red;
    margin-left: 5px;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 14px 0;
  }
  .item:not(:last-child) {
    border-bottom: #ececec 1px solid;
  }
  .beizhu {
    display: flex;
    align-items: flex-start;
  }
  .text {
    width: 100%;
    height: 100px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 5px 10px;
  }
}

.returnBnt {
  width: 200px;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 25px;
  text-align: center;
  padding: 10px;
  background: red;
  color: white;
}
.returnBnt:active {
  opacity: 0.8;
}

.mx-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .mx {
    background: #e93323;
    color: #fff;
    line-height: 1;
    font-size: 0.26rem;
    padding: 0.1rem 0.14rem;
    border-radius: 0.1rem;
    margin-right: 0.1rem;
  }
}

/* 授权书弹窗 */
.auth-popup {
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  .auth-popup-header {
    flex-shrink: 0;
    text-align: center;
    font-size: 0.32rem;
    font-weight: bold;
    color: #1a1a1a;
    padding: 0.24rem 0.6rem;
    border-bottom: 0.02rem solid #eee;
  }

  .auth-popup-scroll {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .auth-popup-footer {
    flex-shrink: 0;
    text-align: center;
    padding: 0.22rem 0;
    margin: 0.24rem 0.3rem 0.3rem;
    background: #e93323;
    color: #fff;
    font-size: 0.3rem;
    font-weight: bold;
    border-radius: 0.42rem;

    &:active {
      opacity: 0.85;
    }
  }
}
</style>
